import React, { useEffect, useState } from "react";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import {
  all_routes,
  nationalPermission,
  superPermission,
  distPermission,
  finPermission,
  retPermission,
  matPermission,
} from "../../router/all_routes";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import {
  createEmployee,
  getAllEmployee,
  updateEmployee,
} from "../../../apis/employees";
import EmpSuccess from "../employees/employeeSuccess";
import { ChangeStatus, uploadFile } from "../../../apis/auth";
import Select from "react-select";
import CommonSearch from "../commonSearch";
import { errorAlert, successAlert } from "../../../style/scss/utils/Alerts";
import { Moment } from "moment";
import {
  getAllNationals,
  getAllNationalsDistributor,
  getAllNationalsFinancer,
  getAllNationalsRetailer,
  getAllNationalsSuper_Distributor,
} from "../../../apis/nationals";
import Newloader from "../employees/loader";
import { formatDate } from "../../../environment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import autoTable from "jspdf-autotable";

type PasswordField = "password" | "confirmPassword";

const StaffList = () => {
  const initialValues = {
    full_name: "",
    user_name: "",
    email: "",
    password: "",
    confirm_password: "",
    phone_number: "",
    about: "",
    geo_location: "",
  };
  const [state, setState] = useState<{
    start: Moment | undefined;
    end: Moment | undefined;
  }>({
    start: undefined,
    end: undefined,
  });
  const { start, end } = state;
  const addressState = {
    addressLine: "",
    city: "",
    states: "",
    country: "",
    pincode: "",
  };
  const [address, setAddress] = useState(addressState);
  const { city, states, country, pincode, addressLine } = address;
  const [plans, setPlans] = useState<any>();
  const [type, setType] = useState<any>();
  const [routePermit, setRoutePermit] = useState<any>();
  const [allEmployeeData, setEmployeeData] = useState<EmployeeData[]>([]);
  const [filteredData, setFilteredData] = useState<EmployeeData[]>([]);
  const [selectedOption, setSelectedOption] = useState<any>();
  const [successCreation, setSuccessCreation] = useState<boolean>(false);
  const [image, setImage] = useState<File | null>(null);
  const [imageUrl, setImageUrl] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [formData, setFormData] = useState(initialValues);
  const [selectedNatOption, setSelectedNatOption] = useState<any>();
  const [finSelectedOption, setFinSelectedOption] = useState<any>();
  const [departFin, setDepartFin] = useState<any>([]);
  const [filteredOptions, setFilteredOptions] = useState<any>([]);
  const [isEdit, setIsEdit] = useState<any>(false);
  const [routes, setRoutes] = useState<any>();
  const [userId, setUserID] = useState<any>();
  const [idCardForm, setIdCardForm] = useState({
    department: "",
    designation: "",
  });
  const [payslipForm, setPayslipForm] = useState({
    department: "",
    designation: "",
    basicSalary: "",
    hra: "",
    bonus: "",
    pf: "",
    tax: "",
    other: "",
    month: "",
  });
  const allOptions = [
    { value: "national", label: "National" },
    { value: "super_distributor", label: "Super Distributor" },
    { value: "distributor", label: "Distributor" },
    { value: "financer", label: "Financer" },
    { value: "retailer", label: "Branch" },
  ];

  const natOptions = [
    { value: "super_distributor", label: "Super Distributor" },
    { value: "distributor", label: "Distributor" },
    { value: "financer", label: "Financer" },
    { value: "retailer", label: "Branch" },
  ];
  const [selectedEmployeeCard, setSelectedEmployeeCard] = useState<any>(null);
  const [selectedPayslip, setSelectedPayslip] = useState<any>(null);
  const userInformation = JSON.parse(sessionStorage.getItem("info"));
  const [showIdModal, setShowIdModal] = useState(false);
  const [showPayslipModal, setShowPayslipModal] = useState(false);

  const sup_dist_options = [{ value: "distributor", label: "Distributor" }];
  const dist_options = [
    { value: "financer", label: "Financer" },
    { value: "retailer", label: "Branch" },
  ];
  const fin_options = [{ value: "retailer", label: "Branch" }];
  const handleIdCardChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;

    setIdCardForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePayslipChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = e.target;

    setPayslipForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const openIDCardPopup = (record: any) => {
    setSelectedEmployeeCard(record);

    setIdCardForm({
      department: record?.CurrentRole || "",
      designation: record?.Designation || "",
    });

    setShowIdModal(true);
  };

  const openPayslipPopup = (record: any) => {
    setSelectedPayslip(record);

    setPayslipForm({
      department: record?.CurrentRole || "",
      designation: record?.Designation || "",
      basicSalary: "",
      hra: "",
      bonus: "",
      pf: "",
      tax: "",
      other: "",
      month: "",
    });

    setShowPayslipModal(true);
  };


  const getImageAsDataUrl = async (url: string): Promise<string> => {
    const response = await fetch(url, { mode: "cors" });
    const blob = await response.blob();

    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();

      reader.onloadend = () => {
        if (typeof reader.result === "string") {
          resolve(reader.result);
        } else {
          reject(new Error("Failed to convert image to data URL"));
        }
      };

      reader.onerror = () => reject(reader.error);

      reader.readAsDataURL(blob);
    });
  };

  const downloadIDCard = async () => {

    if (!selectedEmployeeCard) return;

    const doc = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: [90, 140],
    });
    try {
      doc.addImage(
        "/assets/idcrdbg.jpg",
        "JPEG",
        0,
        0,
        90,
        140
      );
    } catch (err) {
      console.log("Background not found");
    }
    try {
      doc.addImage(
        "/assets/logo1.png",
        "PNG",
        3,
        18,
        18,
        18
      );
    } catch (err) {
      console.log("Logo not found");
    }
    doc.setFont(
      "helvetica",
      "bold"
    );
    doc.setFontSize(12);
    doc.setTextColor(20, 30, 90);
    doc.text(
      "VASUDEVLOKA MICRO",
      24,
      24
    );
    doc.text(
      "SERVICES FOUNDATION",
      24,
      28.5
    );
    doc.setFont(
      "helvetica",
      "normal"
    );
    doc.setFontSize(7);
    doc.setTextColor(100);
    doc.text(
      "Gali No. 11, Peoda Road, Near Dada Khera",
      24,
      32.5
    );
    doc.text(
      "Kaithal, Haryana, India - 136027",
      24,
      35.5
    );
    doc.setDrawColor(25, 40, 120);
    doc.setLineWidth(1.5);
    doc.circle(45, 58, 18);
    try {
      const employeeImage = selectedEmployeeCard?.allDetails?.profile_pic;

      if (employeeImage) {
        const imageUrl = `${employeeImage}${employeeImage.includes("?") ? "&" : "?"}t=${Date.now()}`;
        const dataUrl = await getImageAsDataUrl(imageUrl);

        const img = new Image();
        img.src = dataUrl;

        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });

        const canvas = document.createElement("canvas");
        const size = 400;
        canvas.width = size;
        canvas.height = size;

        const ctx = canvas.getContext("2d");

        if (ctx) {
          ctx.clearRect(0, 0, size, size);

          ctx.save();
          ctx.beginPath();
          ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
          ctx.closePath();
          ctx.clip();

          const aspect = img.width / img.height;
          let drawWidth = size;
          let drawHeight = size;
          let offsetX = 0;
          let offsetY = 0;

          if (aspect > 1) {
            drawWidth = size * aspect;
            offsetX = -(drawWidth - size) / 2;
          } else {
            drawHeight = size / aspect;
            offsetY = -(drawHeight - size) / 2;
          }

          ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
          ctx.restore();

          const circularImage = canvas.toDataURL("image/png");
          doc.addImage(circularImage, "PNG", 27, 40, 36, 36);

          doc.setDrawColor(25, 40, 120);
          doc.setLineWidth(1.5);
          doc.circle(45, 58, 18);
        }
      }
    } catch (err) {
      console.log("Image error", err);
    }
    const employeeName =
      selectedEmployeeCard?.allDetails
        ?.full_name || "";

    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.setTextColor(20);

    doc.setFontSize(16);

    doc.text(
      employeeName.toUpperCase(),
      45,
      85,
      {
        align: "center",
        maxWidth: 72,
      }
    );

    doc.setFontSize(16);

    doc.setTextColor(0);

    doc.text(
      `${idCardForm.designation ||
      "EMPLOYEE"
      }`,
      45,
      92.5,
      {
        align: "center",
      }
    );
    doc.setFontSize(13);
    doc.text(
      `Department : ${idCardForm.department ||
      "HR"
      }`,
      45,
      100,
      {
        align: "center",
      }
    );
    doc.setFontSize(15);
    doc.setTextColor(120);
    doc.text(
      `ID No. : VASU-${selectedEmployeeCard?.id || ""
      }`,
      45,
      108,
      {
        align: "center",
      }
    );
    doc.setFontSize(10);
    doc.setTextColor(90);
    doc.text(
      `Email : ${selectedEmployeeCard?.allDetails?.email || ""
      }`,
      45,
      113,
      {
        align: "center",
        maxWidth: 70,
      }
    );
    doc.text(
      `Contact No. : ${selectedEmployeeCard?.allDetails
        ?.phone_number || ""
      }`,
      45,
      122,
      {
        align: "center",
      }
    );
    doc.setFontSize(3.5);
    doc.setTextColor(255);
    doc.text(
      "Authorized Employee Identity Card",
      45,
      137,
      {
        align: "center",
      }
    );
    doc.save(
      `${selectedEmployeeCard?.allDetails
        ?.full_name || "employee"
      }-ID-Card.pdf`
    );

  };

  const downloadPayslip = () => {
    if (!selectedPayslip) return;

    // A4 PORTRAIT

    const doc = new jsPDF("p", "mm", "a4");

    // VALUES

    const basicSalary = Number(
      payslipForm.basicSalary || 0
    );

    const hra = Number(
      payslipForm.hra || 0
    );

    const bonus = Number(
      payslipForm.bonus || 0
    );

    const otherAllowance = Number(
      payslipForm.other || 0
    );

    const pf = Number(
      payslipForm.pf || 0
    );

    const tax = Number(
      payslipForm.tax || 0
    );

    const other = Number(
      payslipForm.other || 0
    );

    const grossSalary =
      basicSalary +
      hra +
      bonus +
      otherAllowance;

    const totalDeduction =
      pf +
      tax +
      other;

    const netPay =
      grossSalary - totalDeduction;

    // PAGE BORDER

    doc.setDrawColor(180);

    doc.rect(4, 4, 289, 289);

    // LOGO

    try {
      doc.addImage(
        "/assets/logo1.png",
        "PNG",
        10,
        10,
        30,
        30
      );
    } catch (err) {
      console.log("Logo not found");
    }

    // COMPANY NAME

    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.setFontSize(17);

    doc.setTextColor(60);

    doc.text(
      "VITALFLOW MICRO CARE FOUNDATION",
      40,
      22
    );

    // ADDRESS

    doc.setFont(
      "helvetica",
      "normal"
    );

    doc.setFontSize(9);

    doc.setTextColor(90);

    doc.text(
      "Ward No-31 Shiv Lok Colony, Domi Road, Hapur, Ghaziabad, Hapur, Uttar Pradesh, India-245101",
      40,
      28
    );

    // LINE

    doc.setDrawColor(220);

    doc.line(10, 45, 198, 45);

    // TITLE

    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.setFontSize(18);

    doc.setTextColor(70);

    doc.text(
      `Salary Slip for ${payslipForm.month ||
      "10/05/2026"
      }`,
      105,
      60,
      {
        align: "center",
      }
    );

    // EMPLOYEE DETAILS

    doc.setFontSize(12);

    // LEFT DETAILS

    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.text(
      "Name :",
      12,
      78
    );

    doc.text(
      "Email :",
      12,
      90
    );

    doc.setFont(
      "helvetica",
      "normal"
    );

    doc.text(
      `${selectedPayslip?.allDetails
        ?.full_name || ""
      }`,
      38,
      78
    );

    doc.text(
      `${selectedPayslip?.allDetails
        ?.email || ""
      }`,
      38,
      90
    );

    // RIGHT DETAILS

    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.text(
      "Contact Number:",
      115,
      78
    );

    doc.text(
      "Employee Id :",
      115,
      90
    );

    doc.setFont(
      "helvetica",
      "normal"
    );

    doc.text(
      `${selectedPayslip?.allDetails
        ?.phone_number || ""
      }`,
      160,
      78
    );

    doc.text(
      `${selectedPayslip?.id || ""}`,
      150,
      90
    );

    // DIVIDER

    doc.setDrawColor(220);

    doc.line(10, 102, 198, 102);

    // EARNINGS TITLE

    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.setFontSize(16);

    doc.setTextColor(100);

    doc.text(
      "Earnings",
      50,
      118
    );

    // DEDUCTIONS TITLE

    doc.text(
      "Deductions",
      135,
      118
    );

    // EARNINGS TABLE

    autoTable(doc, {
      startY: 125,

      margin: {
        left: 10,
      },

      tableWidth: 85,

      body: [
        [
          "Basic Salary",
          `${basicSalary}`,
        ],

        [
          "HRA",
          `${hra}`,
        ],

        [
          "Bonus Allowances",
          `${bonus}`,
        ],

        [
          "Other Allowances",
          `${otherAllowance}`,
        ],

        [
          "Gross Salary",
          `${grossSalary}`,
        ],
      ],

      styles: {
        fontSize: 10,
        cellPadding: 4,
        lineColor: [210, 210, 210],
        lineWidth: 0.3,
      },

      theme: "grid",

      bodyStyles: {
        textColor: [40, 40, 40],
      },

      alternateRowStyles: {
        fillColor: [252, 252, 252],
      },

      didParseCell: (data) => {
        if (data.row.index === 4) {
          data.cell.styles.fontStyle =
            "bold";
        }
      },
    });

    // DEDUCTIONS TABLE

    autoTable(doc, {
      startY: 125,

      margin: {
        left: 110,
      },

      tableWidth: 85,

      body: [
        [
          "PF Deduction",
          `${pf}`,
        ],

        [
          "Other Deductions",
          `${tax}`,
        ],

        [
          "Leave Deductions",
          `${other}`,
        ],

        [
          "Total Deductions",
          `${totalDeduction}`,
        ],
      ],

      styles: {
        fontSize: 10,
        cellPadding: 4,
        lineColor: [210, 210, 210],
        lineWidth: 0.3,
      },

      theme: "grid",

      bodyStyles: {
        textColor: [40, 40, 40],
      },

      alternateRowStyles: {
        fillColor: [252, 252, 252],
      },

      didParseCell: (data) => {
        if (data.row.index === 3) {
          data.cell.styles.fontStyle =
            "bold";
        }
      },
    });

    // NET PAY SECTION

    doc.setDrawColor(220);

    doc.line(10, 210, 198, 210);

    doc.setFillColor(
      248,
      250,
      252
    );

    doc.roundedRect(
      10,
      218,
      188,
      20,
      3,
      3,
      "F"
    );

    // NET PAY TEXT

    doc.setFont(
      "helvetica",
      "bold"
    );

    doc.setFontSize(18);

    doc.setTextColor(90);

    doc.text(
      "Net Pay",
      18,
      231
    );

    // NET PAY VALUE

    doc.text(
      `${netPay}`,
      170,
      231
    );

    // FOOTER

    doc.setFontSize(10);

    doc.setTextColor(130);

    doc.setFont(
      "helvetica",
      "normal"
    );

    doc.text(
      "This is a computer generated payslip.",
      65,
      285
    );

    // SAVE PDF

    doc.save(
      `${selectedPayslip?.allDetails
        ?.full_name || "employee"
      }-Payslip.pdf`
    );
  };

  const filterdOption = (data: any) => {
    switch (data) {
      case "master":
        setFilteredOptions(allOptions);
        break;
      case "national":
        setFilteredOptions(natOptions);
        break;
      case "super_distributer":
        setFilteredOptions(sup_dist_options);
        break;
      case "distributer":
        setFilteredOptions(dist_options);
        break;
      case "financer":
        setFilteredOptions(fin_options);
        break;
      default:
        return;
    }
  };
  const filterdRoutes = (data: any) => {
    switch (data) {
      case "master":
        setRoutePermit(matPermission);
        break;
      case "national":
        setRoutePermit(nationalPermission);
        break;
      case "super_distributer":
        setRoutePermit(superPermission);
        break;
      case "distributer":
        setRoutePermit(distPermission);
        break;
      case "financer":
        setRoutePermit(finPermission);
        break;
      case "retailer":
        setRoutePermit(retPermission);
        break;
      default:
        return;
    }
  };

  const handleNatSelect = (option: any | null) => {
    setSelectedNatOption(option || undefined);
    setSelectedOption(undefined);
    setFinSelectedOption(undefined);
    filterApiCalls(option);
  };

  const filterApiCalls = (option: any) => {
    switch (option.value) {
      case "national":
        fetchAllNationals();
        break;
      case "super_distributor":
        fetchAllSuperDistributors();
        break;
      case "distributor":
        fetchAllDistributors();
        break;
      case "financer":
        fetchAllFinancers();
        break;
      case "retailer":
        fetchAllRetailers();
        break;
      default:
        return;
    }
  };

  const fetchAllNationals = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationals(data);
    setDepartFin(
      response.data.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };
  const fetchAllSuperDistributors = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsSuper_Distributor(data);
    const filteredData = response?.data?.superDistributorData;
    const filteredResponse =
      type === "super_distributer"
        ? filteredData?.filter((ele: any) => {
          const types = sessionStorage.getItem("info");
          const parsedData = JSON.parse(types);
          const id = parsedData.id;
          return Number(ele.id) === Number(id);
        })
        : filteredData;
    setDepartFin(
      filteredResponse.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };
  const fetchAllDistributors = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsDistributor(data);
    const filteredData = response?.data?.distributorData;
    setDepartFin(
      filteredData.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };

  const fetchAllFinancers = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsFinancer(data);
    const newResponse = response?.data?.financerAllData;
    setDepartFin(
      newResponse?.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };
  const fetchAllRetailers = async () => {
    const data = {
      start_date: start ? start.format("MM/DD/YYYY") : undefined,
      end_date: end ? end.format("MM/DD/YYYY") : undefined,
    };
    const response = await getAllNationalsRetailer(data);
    const newResponse = response?.data?.retailerAllData;
    setDepartFin(
      newResponse?.map((ele: any) => {
        return {
          value: ele.id,
          label: ele.full_name,
        };
      })
    );
  };

  const handleFinSelect = (option: any | null) => {
    setFinSelectedOption(option || undefined);

    const newResponse = allEmployeeData.filter((ele, i) => {
      return Number(ele.allDetails.user_id) === Number(option?.value);
    });
    setFilteredData(newResponse);
  };

  const {
    full_name,
    user_name,
    email,
    password,
    confirm_password,
    phone_number,
  } = formData;

  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
  };
  const paymentType = [
    { value: "Select", label: "Select" },
    { value: "employee", label: "Employee" },
    { value: "visitor", label: "Visitor" },
  ];
  const retType = [
    { value: "Select", label: "Select" },
    { value: "sales-team", label: "Sales Team" },
  ];
  const financerType = [
    { value: "Select", label: "Select" },
    { value: "manager", label: "Manager" },
    { value: "verfication_person", label: "Verfication Person" },
    { value: "payment_collector", label: "Payment Collector" },
  ];

  const filteredFinancerType = plans
    ? financerType.filter((option) => {
      if (
        (option.value === "payment_collector" &&
          plans.payment_collector > 0) ||
        (option.value === "manager" && plans.total_manager > 0) ||
        (option.value === "verfication_person" && plans.verified_person > 0)
      ) {
        return false;
      }
      return true;
    })
    : [];

  const optionSelect =
    type === "financer"
      ? financerType
      : type === "retailer"
        ? retType
        : paymentType;
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleAddressChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setAddress({ ...address, [name]: value });
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0]; // Optional chaining to handle undefined cases

    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("Image size should be below 10 MB");
        setImage(null);
        return;
      }

      setError("");
      setImage(file);
      const formData = new FormData();
      formData.append("image", file);
      const response = await uploadFile(formData);
      if (response.status === true) {
        setImageUrl(response.data.image);
      }
    }
  };

  const handleCancel = () => {
    setFormData(initialValues);
    setAddress(addressState);
    setIsEdit(false);
    setImage(null);
    setError("");
  };

  type EmployeeResponse = {
    user_info: any;
    address: string;
    profile_pic: any;
    full_name: string;
    Image: string;
    CurrentRole: string;
    email: string;
    phone_number: string;
    Designation: string;
    createdAt: string;
    Status: string;
    id: any;
  };

  type EmployeeData = {
    key: number;
    Name: string;
    Image: string;
    CurrentRole: string;
    Email: string;
    Phone: string;
    Designation: string;
    JoiningDate: string;
    Status: string;
    allDetails: any;
    id: any;
  };
  const [loader, setLoader] = useState(false);
  const fetchAllEmployees = async () => {
    setLoader(true);
    try {
      const data = {
        user_id: userInformation.id,
        user_type: userInformation.type,
        start_date: start ? start.format("MM/DD/YYYY") : undefined,
        end_date: end ? end.format("MM/DD/YYYY") : undefined,
      };
      const response = await getAllEmployee(data);
      const employeeData = response?.data?.map(
        (item: EmployeeResponse, i: number) => ({
          key: `${i + 1}`,
          id: item.id || "--",
          JoiningDate: formatDate(item.createdAt),
          // CurrentRole: item.CurrentRole || "--",
          Name: item.full_name ? item.full_name : "--",
          Email: item.email || "--",
          Phone: item.phone_number || "--",
          address: (() => {
            try {
              const parsed = JSON.parse(item.address);
              return `${parsed.addressLine || ""}, ${parsed.city || ""}, ${parsed.states || ""
                }, ${parsed.country || ""} - ${parsed.pincode || ""}`;
            } catch {
              return "--";
            }
          })(),
          Image: item.profile_pic ? item.profile_pic : "--",
          // Designation: item.Designation || "--",
          Status: item.user_info.status || "--",
          allDetails: item,
        })
      );
      setEmployeeData(employeeData || []);
      setFilteredData(employeeData || []);
    } catch (error) {
      console.error("Error fetching employees:", error);
    } finally {
      setLoader(false);
    }
  };
  const [retPlans, setRetPlans] = useState();

  useEffect(() => {
    const type = sessionStorage.getItem("info");
    const fetchPlanData = sessionStorage.getItem("plan");
    try {
      if (type) {
        const parsedData = JSON.parse(type);
        if (parsedData) {
          setType(parsedData?.type);
          filterdOption(parsedData?.type);
          filterdRoutes(parsedData?.type);
        }
      }
      if (fetchPlanData) {
        const parsedData =
          fetchPlanData && fetchPlanData !== "undefined"
            ? JSON.parse(fetchPlanData)
            : [];
        setPlans(parsedData);
      }

      if (fetchPlanData) {
        const parsedTypeData = JSON.parse(type);
        if (parsedTypeData?.type === "financer") {
          const parsedData = JSON.parse(fetchPlanData);
          const newData = JSON.parse(parsedData[0]?.discription);
          setPlans(newData);
        }
      }
      if (fetchPlanData) {
        const parsedTypeData = JSON.parse(type);
        if (parsedTypeData?.type === "retailer") {
          const parsedData = JSON.parse(fetchPlanData);
          const newData = JSON.parse(parsedData[0]?.discription);
          setRetPlans(newData?.total_retailer_sales_team);
        }
      }
    } catch (error) {
      console.error(error, "error");
    }
    fetchAllEmployees();
  }, [state]);

  const [newStatus, setNewStatus] = useState<any>(null);
  const handleChangeStatus = (data: { id: string; status: string }) => {
    const payload = {
      id: data.id,
      status: data.status,
    };
    setNewStatus(payload);
  };
  const handleSubmitStatus = async (event: any) => {
    event.preventDefault();
    try {
      const payload = {
        status: newStatus?.status,
      };
      const response = await ChangeStatus(newStatus?.id, payload);
      if (response.status === true) {
        successAlert("success", `User Status Changed to ${newStatus?.status}`);
        fetchAllEmployees();
        setNewStatus(null);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  const [selectedEmployee, setSelectedEmployee] = useState<any>();

  const mapRecordToFormData = (record: any) => {
    return {
      full_name: record.allDetails.full_name || "",
      user_name: record.Name || "",
      email: record.allDetails.email || "",
      password: "",
      confirm_password: "",
      phone_number: record.allDetails.phone_number || "",
      about: "",
      geo_location: record.allDetails.geo_location || "",
      permissionRoute: record?.allDetails?.user_info?.permitted_routes || "",
      userData: record?.allDetails?.user_info,
    };
  };

  const mapRecordToaddress = (record: any) => {
    const parsedAddress = JSON.parse(record.allDetails.address || {});
    return {
      addressLine: parsedAddress.addressLine,
      city: parsedAddress.city,
      states: parsedAddress.states,
      country: parsedAddress.country,
      pincode: parsedAddress.pincode,
    };
  };

  const handleEditClick = (record: any) => {
    const mappedData = mapRecordToFormData(record);
    const addressData = mapRecordToaddress(record);
    const permissionRoutes = JSON.parse(mappedData?.permissionRoute) || [];

    const selectedRoutes = permissionRoutes?.map((r: any) => r.route);
    const allRoutes =
      type && routePermit
        ? Object.values(routePermit).map((route) => ({
          route: String(route),
          selected: selectedRoutes.includes(route),
        }))
        : [];
    setUserID(mappedData);
    setRoutes(allRoutes);
    setFormData(mappedData);
    setAddress(addressData);
    setIsEdit(true);
  };

  const columns = [
    {
      title: "Sr No",
      dataIndex: "key",
      render: (text: string) => <div>{text}</div>,
    },
    {
      title: "Date",
      dataIndex: "createdAt",
      render: (_: any, record: EmployeeData) => (
        <div>{formatDate(record?.allDetails?.createdAt) || "--"}</div>
      ),
    },
    {
      title: "Name",
      dataIndex: "Name",
      render: (_: any, record: EmployeeData) => (
        <div className="d-flex align-items-center">
          <div
            className="avatar avatar-md"
            data-bs-toggle="modal"
            data-bs-target="#view_details"
          >
            <img
              src={`${record.Image}`}
              className="img-fluid rounded-circle"
              alt="Employee"
            />
          </div>
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{record.Name}</div>
            </p>
          </div>
        </div>
      ),
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Name.localeCompare(b.Name),
    },
    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Email.localeCompare(b.Email),
    },
    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a: EmployeeData, b: EmployeeData) =>
        a.Phone.localeCompare(b.Phone),
    },
    {
      title: "Parent Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => {
        let parentName = "-";
        if (record?.allDetails?.employee_model_type === "retailer") {
          return record?.allDetails?.retailer?.company_name || "-";
        } else if (record?.allDetails?.employee_model_type === "financer") {
          return record?.allDetails?.financer?.company_name || "-";
        } else if (
          record?.allDetails?.employee_model_type === "super_distributer"
        ) {
          return record?.allDetails?.super_distributer?.company_name || "-";
        } else if (record?.allDetails?.employee_model_type === "distributer") {
          return record?.allDetails?.distributer?.company_name || "-";
        } else if (record?.allDetails?.employee_model_type === "national") {
          return record?.allDetails?.national?.company_name || "-";
        }
        return (
          <div className="ms-2">
            <p className="text-dark mb-0">
              <div>{parentName}</div>
            </p>
          </div>
        );
      },
    },
    {
      title: "Owner Name",
      dataIndex: "address",
      render: (text: string, record: EmployeeData) => (
        <div className="ms-2">
          <p className="text-dark mb-0">
            <div>{record?.allDetails?.created_by?.type}</div>
          </p>
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text: string, record: EmployeeData) => (
        <div className="action-icon d-inline-flex">
          <Link
            to="#"
            className="me-2"
            data-bs-toggle="modal"
            data-bs-target="#add_employee"
            onClick={() => handleEditClick(record)}
          >
            <i className="ti ti-edit" />
          </Link>
          <Link
            to={`/viewstaff?EmployeeData=${encodeURIComponent(
              JSON.stringify(record.id)
            )}`}
          >
            <i className="ti ti-eye" />
          </Link>
          <button
            className="btn btn-primary btn-sm"
            onClick={() => openIDCardPopup(record)}
          >
            ID Card
          </button>

          <button
            className="btn btn-success btn-sm"
            onClick={() => openPayslipPopup(record)}
          >
            Payslip
          </button>

        </div>
      ),
    },
  ];

  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const mtIdString = sessionStorage.getItem("info");
  let mtId: { id: string; user_id: string; type: string } | null = null;
  if (mtIdString) {
    try {
      mtId = JSON.parse(mtIdString);
    } catch (error) {
      console.error("Failed to parse sessionStorage info:", error);
    }
  }

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(allEmployeeData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Staff");
    XLSX.writeFile(workbook, "Staff List.xlsx");
  };

  const setNewRoutes = () => {
    const data =
      type && routePermit
        ? Object.values(routePermit).map((route) => ({
          route: String(route),
          selected: false,
        }))
        : [];
    setRoutes(data);
  };
  useEffect(() => {
    setNewRoutes();
  }, [routePermit, type]);

  const handleSelectChange = (index) => {
    setRoutes((prevRoutes) =>
      prevRoutes.map((item, i) =>
        i === index ? { ...item, selected: !item.selected } : item
      )
    );
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (password !== confirm_password) {
      errorAlert("password and confirm_password should be the same");
      return;
    }
    const selectedRoutes = routes
      .filter((item) => item.selected)
      .map((item) => ({
        route: item.route,
        // read: item.read,
        // write: item.write,
      }));
    setLoader(true);
    const master_Id = mtId?.id;
    const type = mtId?.type;
    const payload = {
      address: address,
      email: formData.email,
      gst_no: "",
      full_name: formData.full_name,
      password: formData.password,
      phone_number: formData.phone_number,
      // prefix_code: formData.prefix_code,
      user_name: formData.user_name,
      geo_location: formData.geo_location,
      profile_pic: imageUrl,
      user_id: master_Id,
      type: selectedOption?.value,
      permitted_routes: selectedRoutes,
      national_id: type === "national" ? master_Id : "",
      super_distributor_id: type === "super_distributer" ? master_Id : "",
      distributor_id: type === "distributer" ? master_Id : "",
      financer_id: type === "financer" ? master_Id : "",
      retailer_id: type === "retailer" ? master_Id : "",
      employeeType: type,
    };

    const updatePayload = {
      address: address,
      email: formData.email,
      full_name: formData.full_name,
      phone_number: formData.phone_number,
      geo_location: formData.geo_location,
      profile_pic: imageUrl,
      user_id: master_Id,
      type: selectedOption?.value,
      permitted_routes: selectedRoutes,
    };
    try {
      if (isEdit) {
        const response = await updateEmployee({
          data: updatePayload,
          id: userId?.userData?.id,
          vendor_id: userId?.userData?.vendor_id,
        });
        if (response.status === true) {
          setSuccessCreation(true);
          fetchAllEmployees();
          setAddress(addressState);
          setFormData(initialValues);
        }
      } else {
        const response = await createEmployee(payload);
        if (response.status === true) {
          setSuccessCreation(true);
          fetchAllEmployees();
          setAddress(addressState);
          setFormData(initialValues);
        }
      }
    } catch (error) {
      errorAlert("error", `${error?.response?.data?.message}`);
    } finally {
      setLoader(false);
    }
    // action={all_routes.employeeList}
  };
  const [openPermissions, setOpenPermissions] = useState(false);
  const generateNext = () => {
    let requiredFields = [
      "email",
      "full_name",
      "password",
      "phone_number",
      "user_name",
    ];

    const isEditBool = isEdit === true || isEdit === "true";

    if (isEditBool) {
      requiredFields = requiredFields.filter((field) => field !== "password");
    }

    const emptyFields = requiredFields.filter((field) => {
      const value = formData[field as keyof typeof formData];
      if (typeof value === "string") {
        return value.trim() === "";
      }
      return value === undefined || value === null || value === "";
    });

    if (emptyFields.length > 0) {
      errorAlert(
        `Please fill out the required fields: ${emptyFields.join(", ")}`
      );
      return;
    }

    setOpenPermissions(true);
  };
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2"></div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2"></div>

              <div className="mb-2">
                {(type === "retailer" &&
                  Number(retPlans) > (filteredData?.length || 0)) ||
                  (type === "financer" &&
                    Number(plans?.total_staff) > (filteredData?.length || 0)) ||
                  type === "national" ||
                  type === "super_distributer" ||
                  type === "distributer" ? (
                  <Link
                    to="#"
                    data-bs-toggle="modal"
                    data-inert={true}
                    data-bs-target="#add_employee"
                    className="btn btn-primary d-flex align-items-center"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add New Employee
                  </Link>
                ) : null}
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <CommonSearch
                    allEmployeeData={allEmployeeData}
                    setFilteredData={setFilteredData}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent Role</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {selectedNatOption
                        ? selectedNatOption.label
                        : "Select Role"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {filteredOptions?.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleNatSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <label style={{ color: "#000" }}>Parent User</label>
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#b4b4b447",
                        color: "#00000057",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {finSelectedOption
                        ? finSelectedOption.label
                        : "Select User"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {departFin.map((item) => (
                        <li key={item.value}>
                          <div
                            className="dropdown-item rounded-1"
                            onClick={() => handleFinSelect(item)}
                          >
                            {item.label}
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <div className="input-icon-end position-relative">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                    }}
                  >
                    <label style={{ color: "#000" }}>Date Range</label>
                    <PredefinedDateRanges state={state} setState={setState} />
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    margin: "20px 0px 0px 6rem",
                  }}
                >
                  <div className="dropdown me-3">
                    <Link
                      style={{
                        background: "#3ab54bbf",
                        color: "#fff",
                      }}
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      Export
                    </Link>

                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      {/* <li>
                        <div
                          onClick={exportToPDF}
                          className="btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as PDF
                        </div>
                      </li> */}
                      <li>
                        <div
                          onClick={exportToExcel}
                          className=" btn  dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {loader ? (
              <div className="card-body p-0">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    height: "30vh",
                    alignItems: "center",
                  }}
                >
                  <Newloader />
                </div>
              </div>
            ) : (
              <div className="card-body p-0">
                {filteredData && filteredData.length > 0 ? (
                  <Table
                    dataSource={filteredData}
                    columns={columns}
                    Selection={true}
                  // rowSelection={{ type: "checkbox" }}
                  />
                ) : (
                  <p className="custom-cal-react " style={{ padding: "15px" }}>
                    No Data Found
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Edit Functionality */}
      <div className="modal fade" id="add_employee">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Add New Employee</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>

            <form
            // onSubmit={handleSubmit}
            >
              <div className="contact-grids-tab">
                <ul className="nav nav-underline" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${!openPermissions ? "active" : ""}`}
                      // id="info-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#basic-info"
                      type="button"
                      // role="tab"
                      aria-selected="true"
                      onClick={() => setOpenPermissions(!openPermissions)}
                    >
                      Basic Information
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className={`nav-link ${openPermissions ? "active" : ""}`}
                      // id="address-tab"
                      // data-bs-toggle="tab"
                      // data-bs-target="#permission"
                      type="button"
                      // role="tab"
                      aria-selected="false"
                    >
                      Permissions
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                {!openPermissions && (
                  <div
                  // className="tab-pane fade show active"
                  // id="basic-info"
                  // role="tabpanel"
                  // aria-labelledby="info-tab"
                  // tabIndex={0}
                  >
                    <div className="modal-body pb-0 ">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="d-flex align-items-center flex-wrap row-gap-3 bg-light w-100 rounded p-3 mb-4">
                            <div className="d-flex align-items-center justify-content-center avatar avatar-xxl rounded-circle border border-dashed me-2 flex-shrink-0 text-dark frames">
                              <i className="ti ti-photo text-gray-2 fs-16" />
                            </div>
                            <div className="profile-upload">
                              <div className="mb-2">
                                <h6 className="mb-1">Upload Profile Image</h6>
                                <p className="fs-12">
                                  Image should be below 4 MB
                                </p>
                                {error && (
                                  <p className="text-danger">{error}</p>
                                )}
                              </div>
                              <div className="profile-uploader d-flex align-items-center">
                                <div className="drag-upload-btn btn btn-sm btn-primary me-2">
                                  Upload
                                  <input
                                    type="file"
                                    className="form-control image-sign"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                  />
                                </div>
                                <Link
                                  to="#"
                                  className="btn btn-light btn-sm"
                                  onClick={handleCancel}
                                >
                                  Cancel
                                </Link>
                              </div>
                              {image && (
                                <div className="mt-3">
                                  <p>Preview:</p>
                                  <img
                                    src={URL.createObjectURL(image)}
                                    alt="Profile Preview"
                                    className="img-thumbnail"
                                    style={{
                                      maxWidth: "150px",
                                      maxHeight: "150px",
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Full Name <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="full_name"
                              required
                              value={full_name}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Email <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="email"
                              required
                              name="email"
                              value={email}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Phone Number{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="number"
                              required
                              name="phone_number"
                              value={phone_number}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              User Name <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="user_name"
                              required
                              value={user_name}
                              onChange={handleChange}
                              className="form-control"
                            />
                          </div>
                        </div>

                        {!isEdit && (
                          <>
                            <div className="col-md-6">
                              <div className="mb-3 ">
                                <label className="form-label">
                                  Password{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <div className="pass-group">
                                  <input
                                    type={
                                      passwordVisibility.password
                                        ? "text"
                                        : "password"
                                    }
                                    className="pass-input form-control"
                                    name="password"
                                    required
                                    value={password}
                                    onChange={handleChange}
                                  />
                                  <span
                                    className={`ti toggle-passwords ${passwordVisibility.password
                                      ? "ti-eye"
                                      : "ti-eye-off"
                                      }`}
                                    onClick={() =>
                                      togglePasswordVisibility("password")
                                    }
                                  ></span>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="mb-3 ">
                                <label className="form-label">
                                  Confirm Password{" "}
                                  <span className="text-danger"> *</span>
                                </label>
                                <div className="pass-group">
                                  <input
                                    type={
                                      passwordVisibility.confirmPassword
                                        ? "text"
                                        : "password"
                                    }
                                    className="pass-input form-control"
                                    name="confirm_password"
                                    required
                                    value={confirm_password}
                                    onChange={handleChange}
                                  />
                                  <span
                                    className={`ti toggle-passwords ${passwordVisibility.confirmPassword
                                      ? "ti-eye"
                                      : "ti-eye-off"
                                      }`}
                                    onClick={() =>
                                      togglePasswordVisibility(
                                        "confirmPassword"
                                      )
                                    }
                                  ></span>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {!isEdit && (
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Select Employee Type
                              </label>
                              <Select
                                classNamePrefix="react-select"
                                className="select"
                                options={optionSelect}
                                value={selectedOption}
                                required
                                onChange={handleSelect}
                                placeholder="Select Employee Type"
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Address Line{" "}
                              <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="addressLine"
                              required
                              value={addressLine}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              City <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              required
                              name="city"
                              value={city}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              State <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="states"
                              required
                              value={states}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Country <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="country"
                              required
                              value={country}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label className="form-label">
                              PinCode <span className="text-danger"> *</span>
                            </label>
                            <input
                              type="text"
                              name="pincode"
                              required
                              value={pincode}
                              onChange={handleAddressChange}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-outline-light border me-2"
                        data-bs-dismiss="modal"
                        onClick={handleCancel}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => generateNext()}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                )}
                {openPermissions && (
                  <div>
                    <div className="modal-body">
                      <div className="table-responsive border rounded">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Select</th>
                              <th>Route</th>
                            </tr>
                          </thead>
                          <tbody>
                            {type &&
                              routes?.map((item, index) => (
                                <tr key={item.route}>
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={item.selected}
                                      onChange={() => handleSelectChange(index)}
                                    />
                                  </td>
                                  <td>{item.route}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                          data-bs-dismiss="modal"
                          onClick={handleCancel}
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleSubmit}
                          data-bs-dismiss="modal"
                          className="btn btn-primary"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal fade" id="status_modal">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <div className="d-flex align-items-center">
                <h4 className="modal-title me-2">Change Status</h4>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form onSubmit={handleSubmitStatus}>
              <div
                className="contact-grids-tab"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  marginBottom: "20px",
                }}
              >
                <h3>Are you sure? you want to {newStatus?.status} this user</h3>
                <button
                  type="button"
                  className="btn btn-outline-light border me-2"
                  data-bs-dismiss="modal"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  data-bs-dismiss="modal"
                  className="btn btn-primary"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {showIdModal && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
          }}
        >
          <div
            className="modal-body"
            style={{
              // background: "#f8fafc",
              padding: "30px",
            }}
          >

            {/* FORM SECTION */}

            <div
              className="card border-0 shadow-sm mb-4"
              style={{
                borderRadius: "20px",
                maxWidth: "700px",
                margin: "0 auto",
              }}
            >

              <div className="card-body p-4">

                <div className="row g-4">

                  {/* DEPARTMENT */}

                  <div className="col-md-6">

                    <label
                      className="form-label fw-bold mb-2"
                      style={{
                        color: "#1e293b",
                      }}
                    >
                      Department
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      name="department"
                      value={idCardForm.department}
                      onChange={handleIdCardChange}
                      placeholder="Department"
                      style={{
                        height: "52px",
                        borderRadius: "14px",
                        border:
                          "1px solid #dbe2ea",
                        fontSize: "15px",
                      }}
                    />

                  </div>

                  {/* DESIGNATION */}

                  <div className="col-md-6">

                    <label
                      className="form-label fw-bold mb-2"
                      style={{
                        color: "#1e293b",
                      }}
                    >
                      Designation
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      name="designation"
                      value={idCardForm.designation}
                      onChange={handleIdCardChange}
                      placeholder="Designation"
                      style={{
                        height: "52px",
                        borderRadius: "14px",
                        border:
                          "1px solid #dbe2ea",
                        fontSize: "15px",
                      }}
                    />

                  </div>

                </div>

              </div>

            </div>

            {/* ID CARD CENTER */}

            <div
              className="d-flex justify-content-center"
            >

              <div
                id="popup-id-card"
                style={{
                  width: "340px",
                  height: "620px",
                  background: "#fff",
                  borderRadius: "24px",
                  overflow: "hidden",
                  position: "relative",
                  boxShadow:
                    "0 20px 40px rgba(0,0,0,0.18)",
                  fontFamily:
                    "'Poppins', sans-serif",
                }}
              >

                {/* BACKGROUND */}

                <img
                  src="/assets/idcrdbg.jpg"
                  alt=""
                  style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    top: 0,
                    left: 0,
                    zIndex: 0,
                  }}
                />

                {/* CONTENT */}

                <div
                  style={{
                    position: "relative",
                    zIndex: 2,
                    height: "100%",
                    padding:
                      "40px 25px 30px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >

                  {/* COMPANY */}

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                      marginTop: "35px",
                    }}
                  >

                    <img
                      src="/assets/logo1.png"
                      alt="logo"
                      style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "contain",
                      }}
                    />

                    <div>

                      <h3
                        style={{
                          margin: 0,
                          fontSize: "16px",
                          fontWeight: 700,
                          color: "#1e2a78",
                        }}
                      >
                        VITALFLOW MICRO CARE FOUNDATION
                      </h3>

                      <p
                        style={{
                          margin:
                            "2px 0px 0px",
                          fontSize: "12px",
                          color: "#6b7280",
                        }}
                      >
                        Ward No-31 Shiv Lok Colony, Domi Road, Hapur, Ghaziabad, Hapur, Uttar Pradesh, India-245101
                      </p>

                    </div>

                  </div>

                  {/* PROFILE IMAGE */}

                  <div
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border:
                        "6px solid #1e2a78",
                      background: "#fff",
                      marginTop: "20px",
                      boxShadow:
                        "0 3px 20px rgba(0, 0, 0, 0.06)",
                    }}
                  >

                    <img
                      src={
                        selectedEmployeeCard
                          ?.allDetails
                          ?.profile_pic ||
                        "/assets/default-user.png"
                      }
                      alt="employee"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />

                  </div>

                  {/* DETAILS */}

                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "15px",
                    }}
                  >

                    <h2
                      style={{
                        fontSize: "24px",
                        fontWeight: 700,
                        color: "#1f2947",
                        marginBottom: "10px",
                      }}
                    >
                      {
                        selectedEmployeeCard
                          ?.allDetails
                          ?.full_name
                      }
                    </h2>

                    <h3
                      style={{
                        fontSize: "20px",
                        fontWeight: 700,
                        marginBottom: "8px",
                      }}
                    >
                      "
                      {
                        idCardForm.designation
                      }
                      "
                    </h3>

                    <h4
                      style={{
                        fontSize: "18px",
                        fontWeight: 700,
                        marginBottom: "8px",
                      }}
                    >
                      Department :
                      {" "}
                      {
                        idCardForm.department
                      }
                    </h4>

                    <p
                      style={{
                        color: "#7c7c7c",
                        fontWeight: 600,
                        fontSize: "18px",
                        marginBottom: "4px",
                      }}
                    >
                      ID No. :
                      {" "}
                      VASU-{selectedEmployeeCard?.id}
                    </p>

                    <p
                      style={{
                        color: "#6b7280",
                        fontSize: "14px",
                        lineHeight: "24px",
                        marginBottom: "10px",
                      }}
                    >
                      <strong>
                        Email :
                      </strong>
                      {" "}
                      {
                        selectedEmployeeCard
                          ?.allDetails
                          ?.email
                      }
                    </p>

                    <p
                      style={{
                        color: "#6b7280",
                        fontSize: "14px",
                        marginBottom: "10px",
                      }}
                    >
                      <strong>
                        Phone :
                      </strong>
                      {" "}
                      {
                        selectedEmployeeCard
                          ?.allDetails
                          ?.phone_number
                      }
                    </p>

                  </div>

                </div>

              </div>

            </div>

            {/* FOOTER */}

            <div
              style={{
                marginTop: "30px",
                maxWidth: "700px",
                marginLeft: "auto",
                marginRight: "auto",
                display: "flex",
                justifyContent:
                  "space-between",
                gap: "15px",
              }}
            >

              <button
                type="button"
                onClick={() =>
                  setShowIdModal(false)
                }
                style={{
                  flex: 1,
                  height: "52px",
                  border: "none",
                  borderRadius: "14px",
                  background: "#f1f5f9",
                  color: "#1e293b",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                Close
              </button>

              <button
                type="button"
                onClick={downloadIDCard}
                style={{
                  flex: 1.4,
                  height: "52px",
                  border: "none",
                  borderRadius: "14px",
                  background:
                    "linear-gradient(135deg,#0f172a,#1e3a8a)",
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: 700,
                  boxShadow:
                    "0 8px 20px rgba(30,58,138,0.35)",
                }}
              >
                Download ID Card
              </button>

            </div>

          </div>
        </div>
      )}


      {showPayslipModal && (
        <div
          className="modal show fade"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.7)",
            overflowY: "auto",
          }}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-centered"
            style={{
              maxWidth: "1200px",
            }}
          >
            <div
              className="modal-content border-0"
              style={{
                borderRadius: "20px",
                overflow: "hidden",
              }}
            >

              {/* HEADER */}

              <div
                className="modal-header border-0"
                style={{
                  background:
                    "linear-gradient(90deg,#0f172a,#1e3a8a,#16a34a)",
                  padding: "20px 30px",
                }}
              >
                <div>
                  <h3
                    style={{
                      color: "#fff",
                      margin: 0,
                      fontWeight: 700,
                    }}
                  >
                    Employee Payslip
                  </h3>

                  <p
                    style={{
                      color: "#dbeafe",
                      margin: 0,
                    }}
                  >
                    Generate & Download Salary Slip
                  </p>
                </div>

                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={() => setShowPayslipModal(false)}
                />
              </div>

              {/* BODY */}

              <div
                className="modal-body"
                style={{
                  background: "#f8fafc",
                  padding: "30px",
                }}
              >

                {/* FORM */}

                <div className="card border-0 shadow-sm mb-4">
                  <div className="card-body">

                    <div className="row g-4">

                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          Department
                        </label>

                        <input
                          type="text"
                          className="form-control form-control-lg"
                          name="department"
                          value={payslipForm.department}
                          onChange={handlePayslipChange}
                          placeholder="Department"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          Designation
                        </label>

                        <input
                          type="text"
                          className="form-control form-control-lg"
                          name="designation"
                          value={payslipForm.designation}
                          onChange={handlePayslipChange}
                          placeholder="Designation"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          Month
                        </label>

                        <input
                          type="text"
                          className="form-control form-control-lg"
                          name="month"
                          value={payslipForm.month}
                          onChange={handlePayslipChange}
                          placeholder="May 2026"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          Basic Salary
                        </label>

                        <input
                          type="number"
                          className="form-control form-control-lg"
                          name="basicSalary"
                          value={payslipForm.basicSalary}
                          onChange={handlePayslipChange}
                          placeholder="25000"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          HRA
                        </label>

                        <input
                          type="number"
                          className="form-control form-control-lg"
                          name="hra"
                          value={payslipForm.hra}
                          onChange={handlePayslipChange}
                          placeholder="5000"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          Bonus
                        </label>

                        <input
                          type="number"
                          className="form-control form-control-lg"
                          name="bonus"
                          value={payslipForm.bonus}
                          onChange={handlePayslipChange}
                          placeholder="2000"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          PF
                        </label>

                        <input
                          type="number"
                          className="form-control form-control-lg"
                          name="pf"
                          value={payslipForm.pf}
                          onChange={handlePayslipChange}
                          placeholder="1000"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          Tax
                        </label>

                        <input
                          type="number"
                          className="form-control form-control-lg"
                          name="tax"
                          value={payslipForm.tax}
                          onChange={handlePayslipChange}
                          placeholder="500"
                        />
                      </div>

                      <div className="col-md-4">
                        <label className="form-label fw-bold">
                          Other
                        </label>

                        <input
                          type="number"
                          className="form-control form-control-lg"
                          name="other"
                          value={payslipForm.other}
                          onChange={handlePayslipChange}
                          placeholder="500"
                        />
                      </div>

                    </div>
                  </div>
                </div>

                {/* PAYSLIP */}

                {selectedPayslip && (
                  <div
                    id="popup-payslip"
                    style={{
                      background: "#fff",
                      borderRadius: "20px",
                      overflow: "hidden",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                    }}
                  >

                    {/* TOP */}

                    <div
                      style={{
                        background:
                          "linear-gradient(90deg,#0f172a,#1e3a8a,#16a34a)",
                        padding: "35px",
                        color: "#fff",
                      }}
                    >
                      <div className="d-flex justify-content-between align-items-center">

                        <div>
                          <h1
                            style={{
                              margin: 0,
                              fontWeight: 800,
                              fontSize: "38px",
                            }}
                          >
                            Vakilkaro Pvt Ltd
                          </h1>

                          <p
                            style={{
                              margin: "10px 0px 0px",
                              fontSize: "18px",
                            }}
                          >
                            Employee Salary Payslip
                          </p>
                        </div>

                        <div
                          style={{
                            textAlign: "right",
                          }}
                        >
                          <h3
                            style={{
                              margin: 0,
                            }}
                          >
                            {payslipForm.month}
                          </h3>

                          <p
                            style={{
                              marginTop: "10px",
                            }}
                          >
                            Employee ID :
                            {" "}
                            {selectedPayslip?.id}
                          </p>
                        </div>

                      </div>
                    </div>

                    {/* DETAILS */}

                    <div
                      style={{
                        padding: "35px",
                      }}
                    >

                      <div className="row mb-5">

                        <div className="col-md-6">

                          <div
                            style={{
                              background: "#f8fafc",
                              borderRadius: "15px",
                              padding: "20px",
                            }}
                          >
                            <h5
                              className="mb-4"
                              style={{
                                color: "#1e3a8a",
                                fontWeight: 700,
                              }}
                            >
                              Employee Details
                            </h5>

                            <p>
                              <strong>Name :</strong>
                              {" "}
                              {
                                selectedPayslip?.allDetails
                                  ?.full_name
                              }
                            </p>

                            <p>
                              <strong>Department :</strong>
                              {" "}
                              {payslipForm.department}
                            </p>

                            <p>
                              <strong>Designation :</strong>
                              {" "}
                              {payslipForm.designation}
                            </p>

                          </div>

                        </div>

                        <div className="col-md-6">

                          <div
                            style={{
                              background: "#f8fafc",
                              borderRadius: "15px",
                              padding: "20px",
                            }}
                          >
                            <h5
                              className="mb-4"
                              style={{
                                color: "#16a34a",
                                fontWeight: 700,
                              }}
                            >
                              Salary Summary
                            </h5>

                            <p>
                              <strong>Total Earnings :</strong>
                              {" "}
                              ₹
                              {(
                                Number(
                                  payslipForm.basicSalary || 0
                                ) +
                                Number(
                                  payslipForm.hra || 0
                                ) +
                                Number(
                                  payslipForm.bonus || 0
                                )
                              ).toFixed(2)}
                            </p>

                            <p>
                              <strong>Total Deductions :</strong>
                              {" "}
                              ₹
                              {(
                                Number(
                                  payslipForm.pf || 0
                                ) +
                                Number(
                                  payslipForm.tax || 0
                                ) +
                                Number(
                                  payslipForm.other || 0
                                )
                              ).toFixed(2)}
                            </p>

                            <p
                              style={{
                                fontSize: "22px",
                                color: "#16a34a",
                                fontWeight: 800,
                              }}
                            >
                              Net Salary :
                              {" "}
                              ₹
                              {(
                                Number(
                                  payslipForm.basicSalary || 0
                                ) +
                                Number(
                                  payslipForm.hra || 0
                                ) +
                                Number(
                                  payslipForm.bonus || 0
                                ) -
                                Number(
                                  payslipForm.pf || 0
                                ) -
                                Number(
                                  payslipForm.tax || 0
                                ) -
                                Number(
                                  payslipForm.other || 0
                                )
                              ).toFixed(2)}
                            </p>

                          </div>

                        </div>

                      </div>

                      {/* TABLE */}

                      <div className="table-responsive">

                        <table className="table table-bordered align-middle">

                          <thead
                            style={{
                              background: "#1e3a8a",
                              color: "#fff",
                            }}
                          >
                            <tr>
                              <th>Earnings</th>
                              <th>Amount</th>
                              <th>Deductions</th>
                              <th>Amount</th>
                            </tr>
                          </thead>

                          <tbody>

                            <tr>
                              <td>Basic Salary</td>
                              <td>
                                ₹
                                {payslipForm.basicSalary || 0}
                              </td>

                              <td>PF</td>

                              <td>
                                ₹
                                {payslipForm.pf || 0}
                              </td>
                            </tr>

                            <tr>
                              <td>HRA</td>

                              <td>
                                ₹
                                {payslipForm.hra || 0}
                              </td>

                              <td>Tax</td>

                              <td>
                                ₹
                                {payslipForm.tax || 0}
                              </td>
                            </tr>

                            <tr>
                              <td>Bonus</td>

                              <td>
                                ₹
                                {payslipForm.bonus || 0}
                              </td>

                              <td>Other</td>

                              <td>
                                ₹
                                {payslipForm.other || 0}
                              </td>
                            </tr>

                          </tbody>

                        </table>

                      </div>

                    </div>

                  </div>
                )}

              </div>

              {/* FOOTER */}

              <div
                className="modal-footer border-0"
                style={{
                  padding: "20px 30px",
                  background: "#fff",
                }}
              >

                <button
                  className="btn btn-light btn-lg"
                  onClick={() =>
                    setShowPayslipModal(false)
                  }
                >
                  Close
                </button>

                <button
                  className="btn btn-success btn-lg"
                  onClick={downloadPayslip}
                  style={{
                    padding: "12px 30px",
                    borderRadius: "12px",
                    fontWeight: 700,
                  }}
                >
                  Download Payslip PDF
                </button>

              </div>

            </div>
          </div>
        </div>
      )}
      {successCreation && <EmpSuccess all_routes={all_routes} />}
    </>
  );
};

export default StaffList;
